import React from 'react';
import { IProps } from './types';
import CardHorizontal from 'components/Card/CardHorizontal';
import _ from 'lodash';
import { EventProdList } from 'bff/models/promotion';

const InnerPageASchemes: React.FC<IProps> = (props) => (
  <div className="schemes__inner-page-a-schemes">
    <div className="template-container">
      <div className="template-content">
        {
          _.map(props.EVENT_PROD_LIST, (itemContent: EventProdList, index: number) => {
            return (
              <CardHorizontal
                key={index}
                title={itemContent.TITLE}
                desc={itemContent.DESCTEXT}
                highlightContent={itemContent.HIGHLIGHT}
                btnLink={itemContent.APPLY_URL}
                btnText="我要投保"
                imgUrl={itemContent.PROMO_IMAGE}
                INS_TYPE_ID={itemContent.INS_TYPE_ID}
                PROD_ID={itemContent.PROD_ID}
              />
            );
          })
        }
      </div>
    </div>
  </div>
);

export default InnerPageASchemes;
